const Wishlist = {
  key: 'shopifyWishlist',

  init: function() {
    this.updateAllButtons();
    if (document.getElementById('wishlist-items-container')) {
      this.loadWishlistPage();
    }
    document.dispatchEvent(new CustomEvent('wishlist:init', { detail: { wishlist: this.getItems() } }));
  },

  getItems: function() {
    const items = localStorage.getItem(this.key);
    return items ? JSON.parse(items) : []; // Array de {id, handle}
  },

  saveItems: function(items) {
    localStorage.setItem(this.key, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist: items } }));
    if (document.getElementById('wishlist-items-container')) {
        this.loadWishlistPage(); // Recarrega a página de favoritos para refletir a mudança
    }
  },

  toggle: function(buttonElement, productId, productHandle) {
    let items = this.getItems();
    const SproductId = String(productId);
    const itemIndex = items.findIndex(item => String(item.id) === SproductId);

    if (itemIndex > -1) {
      items.splice(itemIndex, 1);
    } else {
      items.push({ id: SproductId, handle: productHandle });
    }
    this.saveItems(items);
    this.updateButton(buttonElement, SproductId);
  },

  isFavorite: function(productId) {
    const SproductId = String(productId);
    return this.getItems().some(item => String(item.id) === SproductId);
  },

  updateButton: function(buttonElement, productId) {
    if (!buttonElement) return;
    const SproductId = String(productId);
    const isFav = this.isFavorite(SproductId);
    buttonElement.classList.toggle('is-favorite', isFav);

    const addTextEl = buttonElement.querySelector('.wishlist-button__text--add');
    const removeTextEl = buttonElement.querySelector('.wishlist-button__text--remove');
    const iconEmptyEl = buttonElement.querySelector('.icon-heart-empty');
    const iconFilledEl = buttonElement.querySelector('.icon-heart-filled');
    
    let productTitleForLabel = buttonElement.getAttribute('data-product-title') || 
                               buttonElement.getAttribute('data-product-handle')?.replace(/-/g, ' ') || 
                               'este produto';

    if (addTextEl && removeTextEl) {
        addTextEl.style.display = isFav ? 'none' : 'inline-block';
        removeTextEl.style.display = isFav ? 'inline-block' : 'none';
    }
    if (iconEmptyEl && iconFilledEl) {
        iconEmptyEl.style.display = isFav ? 'none' : 'inline-block';
        iconFilledEl.style.display = isFav ? 'inline-block' : 'none';
    }
    
    // Atualiza aria-label usando as chaves de tradução se disponíveis, ou fallback
    const addLabelKey = 'products.product.add_to_wishlist';
    const removeLabelKey = 'products.product.remove_from_wishlist';
    // Nota: a tradução com {{product_title}} é feita pelo Liquid. JS não processa isso.
    // Então, vamos construir o aria-label diretamente ou usar traduções mais simples.
    // Para simplificar, vamos apenas trocar a ação no aria-label.
    if (isFav) {
        buttonElement.setAttribute('aria-label', `Remover ${productTitleForLabel} dos favoritos`);
    } else {
        buttonElement.setAttribute('aria-label', `Adicionar ${productTitleForLabel} aos favoritos`);
    }
  },

  updateAllButtons: function() {
    const buttons = document.querySelectorAll('.wishlist-button');
    buttons.forEach(button => {
      const productId = button.getAttribute('data-product-id');
      if (productId) {
        // Tenta obter o título do produto de um atributo data-product-title (adicionado ao snippet)
        // ou de elementos próximos, se necessário, para o aria-label.
        if (!button.getAttribute('data-product-title')) {
            const productCard = button.closest('.card-wrapper, .product__info-container'); // Ajuste os seletores conforme necessário
            if (productCard) {
                const titleElement = productCard.querySelector('.card__heading a, .product__title h1, .product__title h2');
                if (titleElement) {
                    button.setAttribute('data-product-title', titleElement.textContent.trim());
                }
            }
        }
        this.updateButton(button, productId);
      }
    });
  },

  loadWishlistPage: async function() {
    const container = document.getElementById('wishlist-items-container');
    const emptyMessage = document.getElementById('wishlist-empty-message');
    if (!container || !emptyMessage) return;

    const items = this.getItems();
    container.innerHTML = ''; 

    if (items.length === 0) {
      emptyMessage.style.display = 'block';
      container.style.display = 'none';
      return;
    }

    emptyMessage.style.display = 'none';
    container.style.display = 'grid'; 

    const productPromises = items.map(item => {
      return fetch(`/products/${item.handle}.js`)
        .then(response => {
          if (!response.ok) {
            console.warn(`Produto não encontrado ou erro ao buscar: ${item.handle}`);
            return null; 
          }
          return response.json();
        })
        .catch(error => {
          console.error(`Erro no fetch para ${item.handle}:`, error);
          return null;
        });
    });

    const productsData = await Promise.all(productPromises);

    productsData.forEach(product => {
      if (product && product.id) { 
        const priceMoney = this.formatMoney(product.price);
        let compareAtPriceMoney = '';
        if (product.compare_at_price && product.compare_at_price > product.price) {
          compareAtPriceMoney = `<s class="price-item price-item--regular">${this.formatMoney(product.compare_at_price)}</s>`;
        }

        let imageUrl = product.featured_image || (product.images && product.images.length > 0 ? product.images[0] : null);
        let imageAlt = product.title; // O objeto product do .js não tem product.featured_image.alt diretamente
        
        if (imageUrl) {
            imageUrl = this.getSizedImageUrl(imageUrl, '400x');
        }
        
        const productCardHtml = `
          <div class="grid__item">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--standard card--media card--product" tabindex="-1">
                <div class="card__inner color-background-2 gradient ratio" style="--aspect-ratio-percent: 100%;">
                  <a href="/products/${product.handle}" class="card__media-link" aria-label="Ver produto ${product.title.replace(/"/g, '&quot;')}">
                    <div class="media media--transparent media--hover-effect">
                      ${imageUrl
                        ? `<img src="${imageUrl}"
                             alt="${imageAlt.replace(/"/g, '&quot;')}"
                             loading="lazy"
                             style="object-fit: cover; width: 100%; height: 100%;">`
                        : '<div class="media--placeholder" style="width:100%;min-height:200px;background:#f0f0f0;display:flex;align-items:center;justify-content:center;"><span>Sem Imagem</span></div>'
                      }
                    </div>
                  </a>
                </div>
                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading h5">
                      <a href="/products/${product.handle}" class="full-unstyled-link">
                        ${product.title}
                      </a>
                    </h3>
                    <div class="card-information">
                      <div class="price">
                        <div class="price__container">
                          <div class="price__regular">
                            <span class="visually-hidden visually-hidden--inline">Preço</span>
                            <span class="price-item price-item--sale">${priceMoney}</span>
                            ${compareAtPriceMoney}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="wishlist-button-placeholder" style="margin-top: 15px; text-align: center;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;

        const cardWrapperDiv = document.createElement('div');
        cardWrapperDiv.innerHTML = productCardHtml.trim();
        const productCardElement = cardWrapperDiv.firstChild;

        const wishlistButtonPlaceholder = productCardElement.querySelector('.wishlist-button-placeholder');
        if (wishlistButtonPlaceholder) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'wishlist-button button button--secondary button--small';
            btn.setAttribute('data-product-id', String(product.id));
            btn.setAttribute('data-product-handle', product.handle);
            btn.setAttribute('data-product-title', product.title);
            // Usar as chaves de tradução para os textos dos botões
            const addTextKey = 'products.product.add_to_wishlist_label';
            const removeTextKey = 'products.product.remove_from_wishlist_label';
            // Obter traduções com fallback (o JS não usa o filtro 't' do Liquid)
            // Para simplificar, usamos texto fixo ou você pode passar traduções para o JS via Liquid
            const addText = "Favoritar"; 
            const removeText = "Remover";

            btn.innerHTML = `
                <span class="wishlist-button__icon">
                    <svg class="icon icon-heart-empty" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                    <svg class="icon icon-heart-filled" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:none;"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                </span>
                <span class="wishlist-button__text--add">${addText}</span>
                <span class="wishlist-button__text--remove" style="display:none;">${removeText}</span>`;
            btn.onclick = function() { Wishlist.toggle(this, String(product.id), product.handle); };
            wishlistButtonPlaceholder.appendChild(btn);
            this.updateButton(btn, String(product.id));
        }
        container.appendChild(productCardElement);
      }
    });
  },

  formatMoney: function(cents, formatString) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      try {
        return Shopify.formatMoney(cents, formatString || Shopify.currency.format || "{{amount_with_comma_separator}}");
      } catch (e) {
        // console.warn("Erro Shopify.formatMoney, usando fallback", e);
      }
    }
    const value = (cents / 100).toFixed(2);
    return `R$ ${value.replace('.', ',')}`; // Fallback BRL
  },

  getSizedImageUrl: function(src, size) {
    if (!src || typeof src !== 'string') return '';
    try {
      if (src.includes('cdn.shopify.com')) {
        const parts = src.split('?');
        const path = parts[0];
        const query = parts[1] ? `?${parts[1]}` : '';
        const extensionIndex = path.lastIndexOf('.');
        if (extensionIndex === -1) return src; 
        const basePath = path.substring(0, extensionIndex);
        const extension = path.substring(extensionIndex);
        return `${basePath}_${size}${extension}${query}`;
      }
      return src;
    } catch (e) {
      return src; 
    }
  }
};

document.addEventListener('DOMContentLoaded', function() {
  Wishlist.init();
});